/**
 * @ngdoc service
 * @name checkins.factory:genderizeRsvps
 * @description
 *
 */
// import

class addRsvpToAddressbook {
    constructor(Alert, $http, SweetAlert, $translate) {
        this.key = 'add-rsvp-to-addressbook';
        this.level = 'highlight';
        this.icon = 'address-book';
        this.title = 'Add to address book';
        this.alert = Alert;
        this.api = $http;
        this.sweetAlert = SweetAlert;
        this.accessor = (rsvp) => {
            return !rsvp.contact.data.addressbook;
        };
        this.translate = $translate;
    }

    action(rsvp) {
        const translatedValue = (path, params) => {
            return this.translate.instant(`guestlists.workflows.ask-to-add-to-addressbook-single.${path}`, params);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content', {rsvp_name: rsvp.contact.data.full_name}),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
            },
        ).then(() => {
            return this.api.put(`contacts/${ rsvp.contact.data.id }`, {addressbook: true}).then(response => {
                rsvp.contact = response.data;
                this.alert.success('Success', 'The contact has been added to the address book');
            }, err => this.alert.handle(err));
        }, err => this.alert.handle(err));
    }
}

angular
    .module('festzelt-os.guestlists')
    .factory('addRsvpToAddressbook', [
        'Alert',
        '$http',
        'SweetAlert',
        '$translate',
        (Alert, $http, SweetAlert, $translate) => new addRsvpToAddressbook(Alert, $http, SweetAlert, $translate)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/detailed/add-rsvp-to-addressbook.js